  export const formatDate = (isoString: string) => {
    if (!isoString) return "";
    const d = new Date(isoString);
    if (Number.isNaN(d.getTime())) return isoString;

    const day = String(d.getDate()).padStart(2, "0");
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const y = d.getFullYear();

    return `${day}/${m}/${y}`;
  }

  export const formatLongDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}
  
export const truncateNames = (names: string | string[], limit = 2) => {
  if (!names) return {};

  const nameArray: string[] = typeof names === 'string'
    ? names.split(',').map((n: string) => n.trim())
    : names;

  const visible: string = nameArray.slice(0, limit).join(', ');
  const remaining: number = nameArray.length - limit;

  return { text: visible, extra: remaining };
}